import styled from 'styled-components';
import { COLORS, STYLES } from 'apps/web_forms/utils/constants';

const StyledCheckbox = styled.div`
  .option-container {
    display: flex;
    align-items: center;
    margin: 1em;
    margin-left: 0;
    position: relative;

    .checkbox,
    .checkbox:invalid {
      -webkit-appearance: none;
      -moz-appearance: none;
      border: 1px solid ${COLORS.borderBooleanRadio};
      outline: none;
      transition: box-shadow 0.2s;
      background-color: ${COLORS.booleanInputBackgroundColor};
      border-radius: 0.2em;
      width: 1.25em;
      height: 1.25em;
      padding: 0;
      margin: 0 0.5em 0 0;

      &.invalid {
        border: ${STYLES.ErrorHighlight};
      }
      &.updateHighlight {
        border: ${STYLES.UpdateHighlight};
      }

      &:disabled {
        opacity: 1;
        background-color: ${COLORS.readOnlyBooleanInputBackgroundColor};
      }
      &:active,
      &:focus {
        border: 1px solid ${COLORS.readOnlyInputBackgroundColor};
      }
    }

    .checkbox-label {
      font-weight: ${(props) => (props.checkInsideList ? 100 : 600)};
      margin: 0;
      font-size: ${(props) => (props.checkInsideList ? '0.85em' : '0.9em')};
      position: relative;
      top: 0.1em;
    }

    .check-icon {
      display: none;
      position: absolute;
      top: ${(props) => (props.checkInsideList ? 'unset' : '0.25em')};
      height: 50%;
      left: ${(props) => (props.checkInsideList ? '1em' : '0.2em')};
      pointer-events: none;
    }

    & input:checked {
      background-color: ${COLORS.green};
    }

    & input:checked + .check-icon {
      display: block;
    }
    & input:checked + .checkbox:disabled {
      background-color: ${COLORS.darkGreen};
    }
  }

  .readOnly {
    .checkbox {
      background-color: ${COLORS.readOnlyBooleanInputBackgroundColor};
    }
  }
`;

const StyledMultipleSelectCheckbox = styled(StyledCheckbox)`
  position: relative;
  display: inline-block;

  select {
    outline: none;
    appearance: none;
    display: block;
    padding: 0 0 0 0.6em;
    margin: 0;
    transition: border-color 0.2s;
    border: 1px solid ${COLORS.borderGrey};
    background: ${COLORS.inputBackgroundColor};
    line-height: normal;
    font-family: inherit;
    font-size: inherit;
    min-width: 6em;
    height: 2em;
    border-radius: 0;
    box-sizing: unset;

    &.select-input.invalid {
      border: ${STYLES.ErrorHighlight};
    }
    &.select-input.updateHighlight {
      border: ${STYLES.UpdateHighlight};
    }
  }

  .arrow-icon {
    position: absolute;
    top: calc(50% - 0.35em);
    right: 0.8em;
    transform: rotate(-90deg);
    width: 0.75em;
    height: 0.75em;
    pointer-events: none;
  }

  .overSelect {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  select,
  option.selected {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  select {
    padding-right: 2em !important;
  }

  .checkBoxes {
    display: ${(props) => (props.checkboxes ? 'block' : 'none')};
    padding: 0.5em;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
    animation: fade_in_show 250ms ease-in-out;

    .checkbox {
      margin-left: 1em;
    }
  }

  @keyframes fade_in_show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  #checkBoxes label {
    display: block;
  }

  .multipleSelection {
    width: 300px;
    background-color: #bcc2c1;
  }

  .selectBox {
    position: relative;
  }

  .selectBox select {
    width: 100%;
    font-weight: bold;
  }

  input[type='text'] {
    height: auto !important;
  }
`;

const StyledMultipleSelect = styled(StyledCheckbox)`
  display: flex;
  flex-wrap: wrap;
`;

const StyledLoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.8em;
  color: gray;
  opacity: 0.5em;
  margin: 0.5em 0 0.5em 0;
  span {
    margin-right: 0.5em;
  }
`;

export {
  StyledMultipleSelectCheckbox,
  StyledMultipleSelect,
  StyledLoadingIndicator,
};
